import React from "react";
import { styled } from "../stitches.config";
import { LogInMenu } from "./LogInButton";
import AVControls from "./AVControls";
import SpaceName from "./SpaceName";
import { useAuth } from "../auth/useAuth";
import BuddyList from "./user/BuddyList";
import Overflow from "./NavigationOverflow";
import SkipNav from "./SkipNav";

function Navigation() {
  const { auth } = useAuth();

  return (
    <NavBar
      opaque={true}
      left={
        <>
          <Overflow />
        </>
      }
      center={
        <>
          <SkipNav />
          <Title>
            <SpaceName />
          </Title>
        </>
      }
      right={
        <>
          <AVControls />
          <BuddyList />

          {!auth && <LogInMenu redirect={window.location.pathname} />}
        </>
      }
    />
  );
}

export default Navigation;

interface Props {
  opaque?: boolean;
  left?: React.ReactNode;
  center: React.ReactNode;
  right?: React.ReactNode;
}

export function NavBar({ opaque, left, center, right }: Props) {
  return (
    <Bar opaque={opaque}>
      <Title>{center}</Title>
      <div
        style={{
          justifySelf: "start",
          display: "flex",
          placeItems: "center",
          order: -1, // Title should be first in DOM, so we move left contents via css
        }}
      >
        {left}
      </div>
      <div
        style={{ justifySelf: "end", display: "flex", placeItems: "center" }}
      >
        {right}
      </div>
    </Bar>
  );
}

const Bar = styled("nav", {
  position: "fixed",
  top: "$2",
  left: "$2",
  maxWidth: "calc(100vw - 1rem)",
  display: "flex",
  backgroundBlur: "",
  paddingLeft: "$2",
  paddingRight: "$2",
  height: "$navBarHeight",
  alignContent: "center",
  cursor: "default",
  zIndex: "$navBar",
  borderRadius: "$2",
  variants: {
    opaque: {
      true: {
        background: "$menuBeige",
        backdropFilter: "blur(10px)",
        boxShadow: "$cursor",
      },
    },
  },
});

const Title = styled("div", {
  placeSelf: "center",
  fontWeight: 500,
});
